import React from "react";
import "./TopProfessors.scss";
import CartImage from "../../../assest/images/card-image/ItemAvatar10.png";
import AuthorImage from "../../../assest/images/image.png";
import { TopProfessorsIState } from "./TopProfessors.models";
import ProductAuthorService from "../../../services/content/ProductAuthorService";
import { NavLink } from "react-router-dom";
import { GroupUser } from "../../../models/interfaces/management/GroupUser";

export default class TopProfessors extends React.PureComponent<
  {},
  TopProfessorsIState
> {
  productAuthorService: ProductAuthorService;
  constructor(props: any) {
    super(props);
    this.productAuthorService = new ProductAuthorService();
    this.state = {
      authors: [],
    };
  }

  componentDidMount() {
    this.productAuthorService.getAdvisoryTeam().then((response) => {
      this.setState({
        authors: response,
      });
    });
  }

  renderGroupUserName = (key: GroupUser) => {
    switch (key) {
      case GroupUser.Supporter:
        return "پشتیبان شما";
      case GroupUser.Psychologist:
        return "روانشناس شما";

      default:
        return "مدیر سامانه";
    }
  }

  render(): React.ReactNode {
    let authorsView;
    let { authors } = this.state;

    authorsView = (
      <>
        {authors.map((author, key) => {
          return (
            <div key={key} style={{ padding: " 8px" }}>
              <div className="slide">
                <div className="tk-inline tk-card">
                  <div
                    className="col-6 notspace professor-detail"
                    style={{ padding: "8px !important" }}
                  >
                    <label style={{ padding: "12px 12px 0 0" }}>
                      {author.displayName}
                    </label>
                    <div style={{ padding: "12px 12px 0 0" }}>
                      <span>
                        {!author.isMyAdvisor ? (
                          <b>{this.renderGroupUserName(author.groupUser)}</b>
                        ) : (<b>مشاور شما</b>)}
                      </span>
                    </div>
                  </div>
                  <div className="col-6 notspace professor-image">
                    {author.authorImage === null ? (
                      <img src={AuthorImage} alt="" />
                    ) : (
                      <img
                        src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${author.authorImage}`}
                        alt=""
                      />
                    )}
                  </div>
                </div>
                <div className="col-12 notspace">
                  <div className="tk-inline">
                    <div className={(author.isMyAdvisor ? "col-12 " : "col-6 ") + " notspace"}>
                      {author.isMyAdvisor ? (
                        <NavLink
                          to={`/LecturerInfo?statusPage=${1}&authorId=${author.id
                            }&userId=${author.userId}`}
                        >
                          <button
                            className="btn btn-primary"
                            style={{ width: "100%" }}
                          >
                            مطالعه رزومه
                          </button>
                        </NavLink>
                      ) : (
                        <NavLink
                          to={`/LecturerInfo?statusPage=${1}&authorId=${author.id}`}>
                          <button
                            className="btn btn-primary"
                            style={{ width: "100%" }}
                          >
                            مطالعه رزومه
                          </button>
                        </NavLink>
                      )}
                    </div>
                    {!author.isMyAdvisor ? (
                      <div className="col-6 notspace">
                        <NavLink
                          to={`/LecturerInfo?statusPage=${2}&authorId=${author.id
                            }`}
                        >
                          <button
                            className="btn btn-primary tk-float-left"
                            style={{ width: "98%" }}
                            disabled={author.isMyAdvisor}
                          >
                            نمونه تدریس{" "}
                          </button>
                        </NavLink>
                      </div>
                    ) : (
                      <> </>
                    )}

                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );

    return (
      <>
        <div className="tk-card" style={{ paddingBottom: "35px" }}>
          <div className="tk-inline" style={{ padding: "18px" }}>
            <div className="icon">
              <img src={CartImage} width="64" height="64" alt="" />
            </div>
            <div className="title-top-professor pr-5">
              <label>اعضای تیم مشاوره ای شما</label>
            </div>
          </div>
          <div style={{ overflowY: "hidden" }}>
            {/* <div className="tk-inline d-block">{authorsView}</div> */}
            <div className="tk-inline carousel-custom">{authorsView}</div>
          </div>
        </div>
      </>
    );
  }
}
